import { observer, useSelector } from "@legendapp/state/react"
import { MenuDivider, MenuItem, MenuLabel } from "@mantine/core"
import { IconBuildings } from "@tabler/icons-react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { appStore$ } from "@/stores/app.v2.store"
import Link from "next/link"

export const MenuAdminSection = observer(function MenuAdminSection() {
  const { adminLoginUrl, isAdmin } = useSelector(() => {
    const isAdmin = syncStore$.userStatus.isAdmin.get() || syncStore$.userStatus.isOwner.get()
    const adminURL = syncStore$.cluster.adminUrlS.get()
    const dynamoDbToken = appStore$.userData.dynamoDb.authorizationToken.get()

    const adminLoginUrl = adminURL && dynamoDbToken ? `${adminURL}/login/userLogin?authToken=${encodeURIComponent(dynamoDbToken)}` : "#"

    return {
      isAdmin,
      adminLoginUrl,
    }
  })

  if (!isAdmin) return null

  return (
    <>
      <MenuDivider />
      <MenuLabel>Admin</MenuLabel>
      <MenuItem
        leftSection={
          <IconBuildings
            style={{
              width: "1rem",
              height: "1rem",
            }}
          />
        }
        component={Link}
        href={adminLoginUrl}
        target="_blank"
      >
        Open Admin Panel
      </MenuItem>
    </>
  )
})
